<template>
  <CustomerServicePortalLayout
    portalType="lender" 
    title="Lender Requests"
    description="Explore our selection of convenient options below."
    :backRoute="{ name: 'customerServicePage' }"
  >
    <template #icon>
      <Icon
        icon="fluent:building-bank-20-filled"
        class="text-white text-2xl md:text-3xl"
      />
    </template>
    
    <div class="flex flex-col items-center space-y-4 py-4">
      <router-link
        :to="{ name: 'customerService.lenderRequests.mortgagee' }"
        class="btn-lender min-w-[300px] flex items-center justify-center"
        aria-label="Mortgagee Change Request"
      >
        <Icon
          :icon="mortgageeChangeIcon"
          class="icon mr-2"
          style="font-size: 1.5rem"
          aria-hidden="true"
        />
        <span>Mortgagee Change</span>
      </router-link>

      <router-link
        :to="{ name: 'customerService.lenderRequests.coverage' }"
        class="btn-lender min-w-[300px] flex items-center justify-center"
        aria-label="Coverage Change Request"
      >
        <Icon
          :icon="coverageChangeIcon"
          class="icon mr-2"
          style="font-size: 1.5rem"
          aria-hidden="true"
        />
        <span>Request Coverage Change</span>
      </router-link>

      <router-link
        :to="{ name: 'customerService.lenderRequests.proof' }"
        class="btn-lender min-w-[300px] flex items-center justify-center"
        aria-label="Proof of Insurance Request"
      >
        <Icon
          :icon="proofOfInsuranceIcon"
          class="icon mr-2"
          style="font-size: 1.5rem"
          aria-hidden="true"
        />
        <span>Request Proof of Insurance</span>
      </router-link>
    </div>
  </CustomerServicePortalLayout>
</template>

<script setup>
import { Icon } from '@iconify/vue';
import { ref } from 'vue';
import CustomerServicePortalLayout from '@/components/layout/CustomerServicePortalLayout.vue';

// Typed icon references with descriptive names
const mortgageeChangeIcon = ref('mdi:bank');
const coverageChangeIcon = ref('mdi:shield-check');
const proofOfInsuranceIcon = ref('mdi:file-document-outline');
</script>

<style scoped>
/* Use existing btn-lender styles defined in global stylesheet */
/* Additional component-specific styles could be added here */
.icon {
  flex-shrink: 0;
}

@media (max-width: 640px) {
  .min-w-\[300px\] {
    min-width: 250px;
  }
}
</style> 